import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmFileIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmFileIcon = ({ className, ...props }: EmFileIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3271 21.3125H5.21649C4.94149 21.3125 4.43446 21.3125 3.77962 20.7127C3.25196 20.2297 2.64696 19.7777 2.65899 19.2173L16.8009 2.48187C17.5709 2.48187 17.9198 2.70703 18.4079 2.99922C19.3309 3.55265 19.3618 3.83281 19.3618 4.14562V20.2795C19.3601 20.8502 18.8977 21.3125 18.3271 21.3125Z"
      fill="#B9E4EA"
    />
    <path
      d="M11.8888 15.0597V20.0441H16.8474C17.3922 20.0441 17.834 19.6023 17.834 19.0575V15.0597H11.8888Z"
      fill="#82AEC0"
    />
    <path
      d="M12.9096 20.0441C12.0142 20.0441 13.6401 16.3831 13.6401 16.3831C13.6401 16.3831 17.8339 12.5331 17.8339 15.2058C17.8339 17.8784 13.8034 20.0441 12.9096 20.0441Z"
      fill="#B9E4EA"
    />
    <path
      d="M14.6301 16.5756C14.6301 16.5756 17.8339 16.3711 17.8339 15.1061V3.51484C17.8339 2.94422 17.43 2.48187 16.8009 2.48187H3.6714C2.99249 2.48187 2.63843 2.94422 2.63843 3.51484V19.0111C2.63843 19.5817 3.10077 20.0441 3.6714 20.0441H12.7498C14.7316 19.5766 14.6301 16.5756 14.6301 16.5756Z"
      fill="#F5F5F5"
    />
    <path
      d="M4.83495 4.12329C5.13016 4.12329 5.36948 3.85627 5.36948 3.52689C5.36948 3.1975 5.13016 2.93048 4.83495 2.93048C4.53973 2.93048 4.30042 3.1975 4.30042 3.52689C4.30042 3.85627 4.53973 4.12329 4.83495 4.12329Z"
      fill="#2F7889"
    />
    <path
      d="M5.08244 3.03703C5.00854 2.88234 4.95869 2.68984 4.95869 2.48016C4.95869 1.99719 5.20963 1.58984 5.50697 1.58984C5.80432 1.58984 6.05697 1.99719 6.05697 2.48016H6.86478C6.86478 1.49188 6.25635 0.6875 5.50869 0.6875C4.76104 0.6875 4.15088 1.49188 4.15088 2.48016C4.15088 2.8325 4.22822 3.16078 4.36057 3.4375C4.48088 3.68844 4.74041 3.80016 4.969 3.67812C5.16322 3.57672 5.18729 3.25359 5.08244 3.03703Z"
      fill="#94D1E0"
    />
    <path
      d="M6.28896 1.01578C6.2924 1.02609 6.39208 1.2839 6.25115 1.5314C6.10849 1.78406 5.81287 1.74453 5.81287 1.74453C5.95896 1.90609 6.05693 2.17765 6.05693 2.48015H6.86818C6.86818 1.87515 6.63615 1.34062 6.28896 1.01578Z"
      fill="#2F7889"
    />
    <path
      d="M8.44237 4.12329C8.73758 4.12329 8.9769 3.85627 8.9769 3.52689C8.9769 3.1975 8.73758 2.93048 8.44237 2.93048C8.14715 2.93048 7.90784 3.1975 7.90784 3.52689C7.90784 3.85627 8.14715 4.12329 8.44237 4.12329Z"
      fill="#2F7889"
    />
    <path
      d="M8.69 3.03703C8.61609 2.88234 8.56624 2.68984 8.56624 2.48016C8.56624 1.99719 8.81718 1.58984 9.11453 1.58984C9.41187 1.58984 9.66453 1.99719 9.66453 2.48016H10.4723C10.4723 1.49188 9.8639 0.6875 9.11453 0.6875C8.36687 0.6875 7.75671 1.49188 7.75671 2.48016C7.75671 2.8325 7.83406 3.16078 7.9664 3.4375C8.08671 3.68844 8.34624 3.80016 8.57484 3.67812C8.77078 3.57672 8.79484 3.25359 8.69 3.03703Z"
      fill="#94D1E0"
    />
    <path
      d="M9.8965 1.01578C9.89994 1.02609 9.99963 1.2839 9.85869 1.5314C9.71604 1.78406 9.42041 1.74453 9.42041 1.74453C9.5665 1.90609 9.66447 2.17765 9.66447 2.48015H10.4792C10.4792 1.87515 10.2437 1.34062 9.8965 1.01578Z"
      fill="#2F7889"
    />
    <path
      d="M12.05 4.12329C12.3452 4.12329 12.5846 3.85627 12.5846 3.52689C12.5846 3.1975 12.3452 2.93048 12.05 2.93048C11.7548 2.93048 11.5155 3.1975 11.5155 3.52689C11.5155 3.85627 11.7548 4.12329 12.05 4.12329Z"
      fill="#2F7889"
    />
    <path
      d="M12.2977 3.03703C12.2238 2.88234 12.1739 2.68984 12.1739 2.48016C12.1739 1.99719 12.4248 1.58984 12.7222 1.58984C13.0195 1.58984 13.2722 1.99719 13.2722 2.48016H14.08C14.08 1.49188 13.4716 0.6875 12.7222 0.6875C11.9745 0.6875 11.3644 1.49188 11.3644 2.48016C11.3644 2.8325 11.4417 3.16078 11.5741 3.4375C11.6944 3.68844 11.9539 3.80016 12.1825 3.67812C12.3767 3.57672 12.4025 3.25359 12.2977 3.03703Z"
      fill="#94D1E0"
    />
    <path
      d="M13.504 1.01578C13.5075 1.02609 13.6072 1.2839 13.4662 1.5314C13.3236 1.78406 13.028 1.74453 13.028 1.74453C13.174 1.90609 13.272 2.17765 13.272 2.48015H14.0884C14.0884 1.87515 13.8512 1.34062 13.504 1.01578Z"
      fill="#2F7889"
    />
    <path
      d="M15.6545 4.12329C15.9497 4.12329 16.1891 3.85627 16.1891 3.52689C16.1891 3.1975 15.9497 2.93048 15.6545 2.93048C15.3593 2.93048 15.12 3.1975 15.12 3.52689C15.12 3.85627 15.3593 4.12329 15.6545 4.12329Z"
      fill="#2F7889"
    />
    <path
      d="M15.9036 3.03703C15.8297 2.88234 15.7799 2.68984 15.7799 2.48016C15.7799 1.99719 16.0308 1.58984 16.3281 1.58984C16.6255 1.58984 16.8781 1.99719 16.8781 2.48016H17.686C17.686 1.49188 17.0758 0.6875 16.3281 0.6875C15.5805 0.6875 14.9703 1.49188 14.9703 2.48016C14.9703 2.8325 15.0477 3.16078 15.18 3.4375C15.3003 3.68844 15.5599 3.80016 15.7885 3.67812C15.9827 3.57672 16.0067 3.25359 15.9036 3.03703Z"
      fill="#94D1E0"
    />
    <path
      d="M17.1085 1.01578C17.112 1.02609 17.2117 1.2839 17.0707 1.5314C16.9281 1.78406 16.6324 1.74453 16.6324 1.74453C16.7785 1.90609 16.8765 2.17765 16.8765 2.48015L17.1532 2.49906C17.1532 2.49906 17.4282 2.5214 17.6964 2.62453C17.6964 2.62453 17.7892 1.58468 17.1085 1.01578Z"
      fill="#2F7889"
    />
    <g opacity="0.9">
      <path
        d="M14.4961 17.8802H2.65906V17.5347H14.5614C14.5459 17.722 14.4961 17.8802 14.4961 17.8802Z"
        fill="#4FC3F7"
      />
      <path
        d="M17.363 15.8503H2.65906V15.5049H17.7273C17.5744 15.742 17.363 15.8503 17.363 15.8503Z"
        fill="#4FC3F7"
      />
      <path
        d="M17.8339 13.6486H2.65906"
        stroke="#4FC3F7"
        strokeMiterlimit="10"
        strokeWidth="0.344833"
      />
      <path
        d="M17.8339 11.617H2.65906"
        stroke="#4FC3F7"
        strokeMiterlimit="10"
        strokeWidth="0.344833"
      />
      <path
        d="M17.8339 9.58719H2.65906"
        stroke="#4FC3F7"
        strokeMiterlimit="10"
        strokeWidth="0.344833"
      />
      <path
        d="M17.8339 7.55734H2.65906"
        stroke="#4FC3F7"
        strokeMiterlimit="10"
        strokeWidth="0.344833"
      />
      <path
        d="M17.8339 5.5275H2.65906"
        stroke="#4FC3F7"
        strokeMiterlimit="10"
        strokeWidth="0.344833"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 6.55361L17.8339 5.69939V5.3522L19.3618 6.20986L19.355 6.55361Z"
        fill="#2F7889"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 8.58345L17.8339 7.73095V7.38376L19.3618 8.24142L19.355 8.58345Z"
        fill="#2F7889"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 10.615L17.8339 9.76079V9.4136L19.3618 10.2713L19.355 10.615Z"
        fill="#2F7889"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 12.6449L17.8339 11.7906V11.4435L19.3618 12.3028L19.355 12.6449Z"
        fill="#2F7889"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 14.6764L17.8339 13.8222V13.475L19.3618 14.3327L19.355 14.6764Z"
        fill="#2F7889"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 16.7063L17.8339 15.852V15.5049L19.3618 16.3625L19.355 16.7063Z"
        fill="#2F7889"
      />
    </g>
    <g opacity="0.75">
      <path
        d="M19.355 18.7361L17.8339 17.8819V17.5347L19.3618 18.3941L19.355 18.7361Z"
        fill="#2F7889"
      />
    </g>
  </svg>
);

export default EmFileIcon;
